import * as React from 'react';
import { withStyles } from 'utils/HOCS/withStyles';

export const SectionWrapper = withStyles(
  'section',
  'mx-auto px-4 py-8 max-w-screen-xl flex flex-col items-center md:py-16 md:mb-12',
);
